// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import siteMessage from "@insite/client-framework/SiteMessage";
import parse from "html-react-parser";
import { css } from "styled-components";

/**
 * To Check if string empty by remove empty space and check by string
 * @param value
 */
export const isEmptyString = (value?: string) => (value ? value.trim().length <= 0 : false);

/**
 * To make a word into a form that expresses more than one
 * @param count
 * @param noun
 * @param otherProps
 *
 */
export const pluralize = (
    count: number,
    noun: string,
    otherProps?: { suffix?: string; showNumber?: boolean },
): string => `${otherProps?.showNumber ? `${count} ` : ""}${noun}${count > 1 ? otherProps?.suffix || "s" : ""}`.trim();

export const ellipsis = (maxNoLines: number) => {
    return css`
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${maxNoLines};
    `;
};

/**
 * truncate a text after a certain length
 * or break the last word into new line at a certain length
 * @param  options
 */
export const truncateOrBreakLineText = (options: {
    /**
     * text being processed
     */
    text: string;
    /**
     * string length where the last word should break
     */
    breakAfter?: number;
    /**
     * string length where the text should be truncated
     */
    truncateAfter?: number;
}) => {
    let { text } = options;
    const { truncateAfter, breakAfter } = options;
    if (!text) {
        return "";
    }

    text = text.trim();
    /**
     * if text length exceeded the maximum allowed text,
     * then truncate
     */
    if (truncateAfter && text.length > truncateAfter) {
        return `${text.substring(0, truncateAfter)}...`;
    }
    /**
     * if text length exceeded the break after length,
     * and the text was needed only one character to re-flow
     * then insert a break line before the last word
     */
    if (breakAfter && text.length >= breakAfter && text.length < breakAfter + 2) {
        const newString = text.split(" ");
        const breakIndex = newString.length - 1;
        newString.splice(breakIndex, 0, "<br/>");
        return parse(newString.join(" "), parserOptions);
    }
    return text;
};

/**
 * To return undefined when siteMessage is not exist
 * @param messageName
 */
export const xSiteMessage = (messageName: string) => {
    const message = siteMessage(messageName);
    if (message.toString() === messageName) {
        return undefined;
    }
    return message;
};
